/* istanbul ignore file */
const { httpClient } = require("../catalog.api.js");

const catalogUsers = () =>
  httpClient
    .get(`/users`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const catalogSession = ({ token }) =>
  httpClient
    .post(`/user/session`, { user: { token } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const catalogLogin = ({ email, password, otp_attempt }) =>
  httpClient
    .post(`/user/login`, { user: { email, password, otp_attempt } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const catalogLogout = ({ id, email, token }) =>
  httpClient
    .put(`/user/logout`, { user: { id, email, token } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const catalogUpdateUser = ({ id, email, token, name, authority }) =>
  httpClient
    .put(`/user`, { user: { id, email, token, name, authority } })
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

export {
  catalogUsers,
  catalogSession,
  catalogLogin,
  catalogLogout,
  catalogUpdateUser,
};
